import { createSearchErrorEvent, createSearchErrorEventPayload } from '@qantasexperiences/analytics';
import { getPropertyId } from 'store/property/propertySelectors';
import { fetchPropertyAvailabilityFailure } from 'store/propertyAvailability/propertyAvailabilityActions';

const emitFetchPropertyAvailabilityFailureEvent = (action, prevState) => {
  const errors = [
    {
      code: action.payload.httpStatus,
      message: action.payload.message,
      name: action.payload.message,
    },
  ];
  const propertyId = getPropertyId(prevState);

  const currentUrl = window.location.href;

  const searchErrorEvent = createSearchErrorEvent(
    createSearchErrorEventPayload({
      errors,
      searchTerm: `property ID: ${propertyId}`,
      pageType: 'property',
      url: currentUrl,
    }),
  );

  return searchErrorEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [fetchPropertyAvailabilityFailure]: emitFetchPropertyAvailabilityFailureEvent };
